exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".test-deposit-input{color:#333745!important}.bankaccount a{display:inline-block;color:#36b78b;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/settings/bank_account/bank_account.css
// module id = 823
// module chunks = 0